<template>
  <div class="content has-padding-large">
    <div class="level">
      <div class="level-left">
        <decor-title>
          {{ $route.meta.title }}
          <span
            v-if="
              searchClientsByUser.id !== user.id && searchClientsByUser.name
            "
            >of {{ searchClientsByUser.name }}</span
          >
        </decor-title>
      </div>
      <div class="level-right">
        <!-- <control-button
          class="is-primary is-fullwidth has-margin-right-small"
          @click="deleteClients"
          >Delete Select Clients</control-button
        > -->
        <control-button
          class="is-primary is-fullwidth has-margin-right-small"
          @click="openPopup(null)"
          >Import CSV</control-button
        >
        <control-button class="is-primary is-fullwidth has-margin-right-small">
          <download-excel
            :fields="excelColumns"
            type="csv"
            name="stacks_export.csv"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            :data="checkedExcelData"
            >Export to CSV</download-excel
          >

           <!-- <download-excel
            :fields="excelColumns"
            type="csv"
            name="stacks_export.csv"
            :before-generate="startDownload"
            :before-finish="finishDownload"
            :data="checkedExcelData"
            >{{ exportData.length > 0 ? 'Export Selected' : 'Export to CSV'}}</download-excel
          > -->
        </control-button>
      </div>
    </div>

    <dataset-list ref="datasetList" :clients.sync="clients" :exportData="exportData"
      @clearExport="exportData = []" @setClients="data => clients = data"></dataset-list>
  </div>
</template>

<script>
import { modal } from "@/lib/notif";
import Popup from "./popup";
import DatasetList from "./list";
import { dangerBar, successBar, successToast } from "@/lib/notif";
import { mapState } from "vuex";
import { db, storage } from "@/module/firebase";
import store from "@/store";
import { DateTime } from 'luxon'

export default {
  name: "Clients",
  components: {
    DatasetList
  },
  data() {
    return {
      clients: [],
      exportData: [],
      exportFix:['followup','listingDate','contractDate','closingDate']
     
    };
  },

  computed: {

    ...mapState(["user", "searchClientsByUser"]),
    excelColumns() {
      return require("./export_columns").default;
    },
    checkedExcelData(){
      if(this.exportData.length === 0){
        return this.clients;
      }
      return this.exportData
    },
    
  },
  methods: {
    
    
    openPopup() {
      modal(this, Popup, 560, { reload: this.reload });
    },
    reload() {
      this.$refs.datasetList.$refs.dataset.forceFetch();
    },
    changeFormat(dateValue){
      if(!dateValue) return ''
      if(typeof dateValue === 'string'){
        var jsDate = DateTime.fromISO(dateValue, { setZone: true })
          .setZone('utc')
          .toJSDate()
        return jsDate.toLocaleDateString("en-US")
      }
      else{
        return new Date(dateValue).toLocaleDateString("en-US")
      }
    },
    startDownload() {
    var self = this
    this.clients.map(client => {
      client.followup = self.changeFormat(client.followup)
      client.contractDate = self.changeFormat(client.contractDate)
      client.closingDate = self.changeFormat(client.closingDate)
      client.listingDate = self.changeFormat(client.listingDate)
      
    })
  this.reload();
    },
    finishDownload() {
      successToast("Export Complete");
    }
  }
};
</script>
